import React from 'react';

import QuestionSlider from './QuestionSlider';
import QuestionDollars from './QuestionDollars';
import QuestionPercentage from './QuestionPercentage';
import QuestionRadio from './QuestionRadio';
import QuestionLongAnswer from './QuestionLongAnswer';
import QuestionShortAnswer from './QuestionShortAnswer';
import QuestionRanking from './QuestionRanking';
import QuestionMultipart from './QuestionMultipart';

function QuestionSwitch({ question, answer = {}, handleAnswerChange, saveAnswer }) {
  const value = answer.parts && question.parts
    ? answer.parts[question.parts[0].id]
    : null;
  switch (question.questionType) {
    case 'long_answer':
      return (
        <QuestionLongAnswer
          questionId={question.id}
          label={question.parts[0].label}
          value={value}
          onChange={e => handleAnswerChange({ [question.parts[0].id]: e.target.value })}
        />
      );
    case 'short_answer':
      return (
        <QuestionShortAnswer
          questionId={question.id}
          label={question.parts ? question.parts[0].label : ''}
          value={value}
          hasInput={!!question.parts}
          onChange={e => handleAnswerChange({ [question.parts[0].id]: e.target.value })}
        />
      );
    case 'slider':
      return (
        <QuestionSlider
          label={question.parts[0].label}
          minLabel={question.minLabel}
          maxLabel={question.maxLabel}
          value={value}
          onChange={e => handleAnswerChange({ [question.parts[0].id]: e.target.value })}
          name={question.id}
        />
      );
    case 'percentage':
      return (
        <QuestionPercentage
          questionId={question.id}
          label={question.parts[0].label}
          value={value}
          onChange={e => handleAnswerChange({ [question.parts[0].id]: e.target.value })}
        />
      );
    case 'dollars':
      return (
        <QuestionDollars
          questionId={question.id}
          label={question.parts[0].label}
          value={value}
          onChange={e => handleAnswerChange({ [question.parts[0].id]: e.target.value })}
        />
      );
    case 'radio':
      return (
        <QuestionRadio
          answer={answer}
          onChange={handleAnswerChange}
          parts={question.parts}
          questionId={question.id}
        />
      );
    case 'multipart':
      return (
        <QuestionMultipart
          currentAnswers={answer}
          currentQuestion={question}
          saveAnswer={saveAnswer}
        />
      );
    case 'ranking':
      return (
        <QuestionRanking
          currentAnswers={answer}
          onChange={handleAnswerChange}
          parts={question.parts}
        />
      );
    default:
      return null;
  }
}

export default QuestionSwitch;



// WEBPACK FOOTER //
// ./src/components/features/assessment/QuestionSwitch.js